// extracted by mini-css-extract-plugin
export default {"section":"fixed-button_section__YObZy","visible":"fixed-button_visible__ovVEd","inner":"fixed-button_inner__PLDCS"};